/**
 * Team Member API endpoints
 */
import axiosClient from './axiosClient';
import { TeamMember } from '@/types';

export const teamMemberAPI = {
  /**
   * Get team members (optionally filtered by team)
   */
  getTeamMembers: async (
    teamId?: string,
    params?: { skip?: number; limit?: number }
  ): Promise<TeamMember[]> => {
    const response = await axiosClient.get<TeamMember[]>('/team-members', {
      params: {
        team_id: teamId,
        skip: params?.skip,
        limit: params?.limit,
      },
    });
    return response.data;
  },

  getAllTeamMembers: async (
    teamId: string,
    params?: { skip?: number; limit?: number }
  ): Promise<TeamMember[]> => {
    const response = await axiosClient.get<TeamMember[]>(
      `/teams/${teamId}/members`,
      {
        params: {
          skip: params?.skip,
          limit: params?.limit,
        },
      }
    );
    return response.data;
  },

  /**
   * Add member to team
   */
  addMember: async (memberData: {
    team_id: string;
    user_id: string;
    role: string;
  }): Promise<TeamMember> => {
    const response = await axiosClient.post<TeamMember>('/team-members', memberData);
    return response.data;
  },

  /**
   * Bulk add members to team and all team projects
   */
  bulkAddMembers: async (data: {
    team_id: string;
    user_ids: string[];
    role: string;
    project_ids: string[];
    membership_type?:string;
  }): Promise<TeamMember[]> => {
    const response = await axiosClient.post<TeamMember[]>('/team-members/bulk', data);
    return response.data;
  },

  /**
   * Update team member
   */
  updateMemberFromTeamProjects: async (data: {
    team_id: string;
    user_id: string;
    new_role: 'admin' | 'member' | 'viewer';
  }): Promise<TeamMember[]> => {
    const response = await axiosClient.put<TeamMember[]>(
      `/team-members/update-member-from-team-projects/${data.user_id}?team_id=${data.team_id}`,
      { role: data.new_role }
    );
  
    return response.data;
  },
  
  /**
   * Remove member from team
   */
  removeMemberFromTeamProjects: async (data: {
    team_id: string;
    user_id: string;
  }): Promise<TeamMember[]> => {
    const response = await axiosClient.post<TeamMember[]>(`/team-members/remove-from-team-projects?team_id=${data.team_id}&user_id=${data.user_id}`);
    return response.data;
  },

  
};
